/* Threads on Design - moved here from the snippets listed below on 18 OCT 2026 (TEST 6) so phones keep it between pages.
   Edit it here; the notes stay in that file. */

/* ---- snippets/tod-bestseller.liquid ---- */
try {
(function () {
  'use strict';
  var SEL = '.tod a.setcard[href*="/pages/signature"], .tod a.ss-card[href*="/pages/signature"], .tod a.tpick-t[href*="/pages/signature"]';

  function tag() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.querySelector('.tod-bs')) { continue; }
      el.classList.add('tod-bs-host');
      var b = document.createElement('span');
      b.className = 'tod-bs' + (el.classList.contains('tpick-t') ? ' sm' : '');
      b.innerHTML = '<span>Best seller</span>';
      el.appendChild(b);
    }
  }

  function pass() { try { tag(); } catch (e) {} }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pass); } else { pass(); }
  setTimeout(pass, 800);
  setTimeout(pass, 2000);
})();
} catch (e) { setTimeout(function () { throw e; }); }

/* ---- snippets/tod-setcolors.liquid ---- */
try {
(function () {
  'use strict';
  var RX = /(\b\d+\s+(?:cutting\s+|salon\s+)?(?:capes?|aprons?)\b|\bFour or more\b)/gi;
  function bold() {
    var els = document.querySelectorAll('.tod a.tpick-t small, .tod a.setcard .setwhat li, .tod a.ss-card .ss-body p');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-tod-qty') || el.children.length) { continue; }
      var t = el.textContent;
      if (!RX.test(t)) { continue; }
      RX.lastIndex = 0;
      el.innerHTML = t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(RX, '<span class="tod-qty">$1</span>');
      el.setAttribute('data-tod-qty', '1');
    }
  }
  function pass() { try { bold(); } catch (e) {} }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pass); } else { pass(); }
  setTimeout(pass, 900);
  setTimeout(pass, 2200);
})();
} catch (e) { setTimeout(function () { throw e; }); }

/* ---- snippets/tod-howmini.liquid ---- */
try {
(function () {
  'use strict';
  if (!window.matchMedia || !matchMedia('(max-width: 767px)').matches) { return; }
  var LABELS = ['Design it', 'Mockup in 30 min', 'Stitch & ship'];

  function build() {
    var hw = document.querySelector('.tod .hw');
    if (!hw || hw.classList.contains('hw-mini')) { return; }
    var its = hw.querySelectorAll('.hw-it');
    if (its.length < 2) { return; }
    var steps = [];
    for (var i = 0; i < its.length; i++) {
      var h = its[i].querySelector('h3'), p = its[i].querySelector('p'), n = its[i].querySelector('b');
      steps.push({ n: n ? n.textContent.trim() : String(i + 1), h: h ? h.innerHTML : '', p: p ? p.innerHTML : '',
                   l: LABELS[i] || (h ? h.textContent.trim() : '') });
    }

    var box = document.createElement('div');
    box.className = 'hwm';
    var row = '<div class="hwm-row" role="tablist">';
    for (var k = 0; k < steps.length; k++) {
      row += '<button type="button" class="hwm-s' + (k === 0 ? ' on' : '') + '" role="tab" aria-selected="' + (k === 0) + '" data-i="' + k + '">'
        + '<b>' + steps[k].n + '</b><span>' + steps[k].l + '</span></button>';
    }
    row += '</div><div class="hwm-panel" role="tabpanel" aria-live="polite"><h3></h3><p></p></div>';
    box.innerHTML = row;

    var grid = hw.querySelector('.hw-grid');
    grid.parentNode.insertBefore(box, grid.nextSibling);
    hw.classList.add('hw-mini');

    var ph = box.querySelector('.hwm-panel h3'), pp = box.querySelector('.hwm-panel p');
    var btns = box.querySelectorAll('.hwm-s');
    function show(i) {
      ph.innerHTML = steps[i].h;
      pp.innerHTML = steps[i].p;
      for (var j = 0; j < btns.length; j++) {
        btns[j].classList.toggle('on', j === i);
        btns[j].setAttribute('aria-selected', j === i ? 'true' : 'false');
      }
    }
    for (var m = 0; m < btns.length; m++) {
      btns[m].addEventListener('click', function () { show(+this.getAttribute('data-i')); });
    }
    show(0);
  }

  function pass() { try { build(); } catch (e) {} }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pass); } else { pass(); }
  setTimeout(pass, 700);
})();
} catch (e) { setTimeout(function () { throw e; }); }
